import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { AppContext } from '@prisjakt/ui-app-context';
import Search from '@prisjakt/ui-search';
import { Search as SearchInput } from '@prisjakt/ui-inputs';
import * as S from './styles';

class SearchProduct extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { search: '', hasResults: false, results: [] };
    this.searchInput = React.createRef();
  }

  componentDidMount() {
    if (this.props.focusOnMount && this.searchInput.current) {
      const input = this.searchInput.current.querySelector(
        'input[type="text"]'
      );
      if (input) {
        setTimeout(() => input.focus(), 100);
      }
    }
  }

  render() {
    const { placeholder, showFloatingResult, onSelect } = this.props;
    const { search, results } = this.state;
    const hasResults =
      this.state.hasResults && search !== '' && results && results.length > 0;
    return (
      <>
        <S.SearchInput ref={this.searchInput} hasResults={hasResults}>
          <SearchInput
            key="search"
            placeholder={
              placeholder ||
              this.context.t('search', 'search-products.placeholder')
            }
            hasResults={hasResults}
            onChange={searchTerm => {
              this.setState({
                search: searchTerm,
                hasResults: false,
              });
            }}
          />
        </S.SearchInput>
        <S.SearchResult hasResults={hasResults} floating={showFloatingResult}>
          <Search
            query={search}
            onSelect={onSelect}
            showAllResults={false}
            keyboardNavigation={false}
            styling="none"
            disableScrollToTop
            onSearchResultFound={items =>
              this.setState({
                hasResults: true,
                results:
                  items && items[0] && items[0].hits ? items[0].hits : [],
              })
            }
            options={{
              groups: [
                {
                  limit: 5,
                  name: 'products',
                  modes: ['product'],
                },
              ],
            }}
          />
        </S.SearchResult>
      </>
    );
  }
}

SearchProduct.contextType = AppContext;

SearchProduct.propTypes = {
  onSelect: PropTypes.func,
  showFloatingResult: PropTypes.bool,
  focusOnMount: PropTypes.bool,
  placeholder: PropTypes.string,
};

SearchProduct.defaultProps = {
  onSelect: () => {},
  showFloatingResult: false,
  focusOnMount: false,
  placeholder: undefined,
};

export default SearchProduct;
